$ = require('jquery')

require('jquery-cycle2')
require('jquery-cycle2/build/plugin/jquery.cycle2.carousel.min')

module.exports =
	init: (payload) ->
		{$target} = payload

		# populate original index for carousels
		$('.box-slider--carousel .box-slider__item').each((i, obj) ->
			$(this).data('index', $(this).index())
			$(this).width( $(this).width() )
		)


		$target.find('.js-slider').each(->
			$thisBox = $(this)
			$list = $thisBox.find('.box-slider__list')
			isCarousel = $thisBox.hasClass('box-slider--carousel') # obrazkový carousel
			isPager = !!($thisBox.closest('.box-slider-pager').length) # carousel s obrázkovým stránkování
			$overlay = $thisBox.find('.box-slider__overlay')
			makeCycle = true

			if isPager and isCarousel
				$list
					.find('.box-slider__item')
					.first()
					.addClass('is-active')

			if $list.find('> .box-slider__item').length < 4 && isCarousel
				makeCycle = false
				$thisBox.find('.box-slider__prev').addClass('is-disabled')
				$thisBox.find('.box-slider__next').addClass('is-disabled')

			if makeCycle
				$list.cycle(
					carouselVisible: do ->
						if isPager
							return 3
						else
							if window.matchMedia('(min-width: 1000px)').matches
								return 4
							else if window.matchMedia('(min-width: 700px)').matches
								return 3
							else
								return 1
					# carouselFluid: true
					disabledClass: 'is-disabled'
					fx: if isCarousel then 'carousel' else 'scrollHorz'
					prev: $thisBox.find('.box-slider__prev')
					next: $thisBox.find('.box-slider__next')
					pager: $thisBox.find('.box-slider__pager')
					pagerActiveClass: 'is-active'
					pagerTemplate: '<a href="#">{{slideNum}}</a>'
					slides: '> .box-slider__item'
					paused: if $thisBox.data('timeout') then false else true
					overlayTemplate: ''
					overlay: $thisBox.find('.box-slider__overlay')
					log: false
					timeout: if $thisBox.data('timeout') then $thisBox.data('timeout') else 0
				)

				$list.on('cycle-update-view', (event, optionHash, slideOptionsHash, currentSlideEl) ->
					$currentSlide =  $(currentSlideEl)
					overlayTemplate = ''

					if $currentSlide.attr('data-title')
						overlayTemplate = overlayTemplate + '<h2 class="box-slider__title">{{title}}</h2>'

					if $currentSlide.attr('data-desc')
						overlayTemplate = overlayTemplate + '<p>{{desc}}</p>'


					if $currentSlide.is('a')
						$overlay.addClass('is-clickable')
					else
						$overlay.removeClass('is-clickable')

					slideOptionsHash.overlayTemplate = overlayTemplate
				)

				$overlay.on('click', ->
					if $(@).hasClass('is-clickable')
						window.location = $thisBox.find('.box-slider__item.cycle-slide-active').attr('href')
				)
		)

		$target.find('.js-slider-pager').each(->
			$sliders = $(this).find('.js-slider')
			$imagesSlider = $sliders.not('.box-slider--carousel').find('.box-slider__list')
			$pagerSlider = $sliders.filter('.box-slider--carousel').find('.box-slider__list')
			makeCycle = true

			if $pagerSlider.find('> .box-slider__item').length < 4
				makeCycle = false

			$pagerItems = $pagerSlider.find('.box-slider__item')

			byPager = false

			getActivePagerItem = ->
				return $pagerItems.filter('.is-active')

			setActivePager = (index) ->
				$pagerItems.removeClass('is-active')
				$pagerItems
					.filter((i, obj) ->
						return $(obj).data('index') is index
					)
					.addClass('is-active')

			$imagesSlider.on('cycle-before', (event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) ->
				if byPager
					byPager = false
				else
					setActivePager(optionHash.nextSlide)
					if forwardFlag
						$pagerSlider.cycle('next')
					else
						$pagerSlider.cycle('prev')
			)


			$pagerItems.on('click', (event) ->
				event.preventDefault()

				$this = $(this)

				byPager = true

				$imagesSlider.cycle('goto', $(this).data('index'))
				setActivePager($this.data('index'))
			)
		)



/** WEBPACK FOOTER **
 ** ./src/js/components/cycle.coffee
 **/